import {
  NEWS_EVENT_SET_SUBSCRIPTION,
  NEWS_EVENT_SET_LISTING,
  NEWS_EVENT_SET_THEMES,
  NEWS_EVENT_SET_TRIGGERS,
  NEWS_EVENT_SET_LANGUAGE,
  NEWS_EVENT_SET_ACTIVE,
  NEWS_EVENT_UPDATE_REQUEST,
  NEWS_EVENT_CREATE_REQUEST,
} from "./consts";

export const setNewsEventSubscription = (payload) => ({
  type: NEWS_EVENT_SET_SUBSCRIPTION,
  payload,
});

export const setNewsEventListing = (payload) => ({
  type: NEWS_EVENT_SET_LISTING,
  payload,
});

export const setThemes = (payload) => ({
  type: NEWS_EVENT_SET_THEMES,
  payload,
});

export const setTriggers = (payload) => ({
  type: NEWS_EVENT_SET_TRIGGERS,
  payload,
});

export const setNewsEventLanguage = (payload) => ({
  type: NEWS_EVENT_SET_LANGUAGE,
  payload,
});

export const setNewsEventActive = (payload) => ({
  type: NEWS_EVENT_SET_ACTIVE,
  payload,
});

export const updateNewsEventSubscriptionRequest = (payload) => ({
  type: NEWS_EVENT_UPDATE_REQUEST,
  payload,
});

export const createNewsEventSubscriptionRequest = (payload) => ({
  type: NEWS_EVENT_CREATE_REQUEST,
  payload,
});
